import { uploadFile } from '../api/endpoints/media';

class CustomUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    const file = await this.loader.file;
    const res = await uploadFile(file);
    return { default: res.data.data.url };
  }

  abort() {}
}

export default function UploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new CustomUploadAdapter(loader);
  };
}
